module.exports = __webpack_public_path__ + "static/f-MLopez-425f2f4b76d16afcded97e2e313ba675.jpg";